/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Secure_TitleInputs */

const en_pc_tut_secure_title = /** @type {(inputs: Pc_Tut_Secure_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open password-protected PDFs`)
};

const zh_pc_tut_secure_title = /** @type {(inputs: Pc_Tut_Secure_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开加密 PDF`)
};

/**
* | output |
* | --- |
* | "Open password-protected PDFs" |
*
* @param {Pc_Tut_Secure_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_secure_title = /** @type {((inputs?: Pc_Tut_Secure_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Secure_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_secure_title(inputs)
	return zh_pc_tut_secure_title(inputs)
});
export { pc_tut_secure_title as "pc.tut.secure.title" }